<script>
    export default {
        data: () => ({
            email: localStorage.getItem("@fluid/lastLogin") || "",
            password: "",
            keepConnected: JSON.parse(localStorage.getItem("@fluid/keep")) || false
        }),

        methods: {
            submit() {
                this.$emit("hasSubmit", {
                    email: this.email,
                    password: this.password
                });
            }
        },

        watch: {
            keepConnected: function(v) {
                window.localStorage.setItem("@fluid/keep", JSON.stringify(v));
            }
        }
    };
</script>

<template>
    <form class='fluid__login__form' @submit.prevent='submit'>
        <v-text-field v-model='email' type='email' label='E-mail' required/>
        <v-text-field v-model='password' type='password' label='Senha' required/>
        <v-checkbox v-model='keepConnected' label='Mantenha-me conectado'/>

        <v-btn block color='primary' type='submit'>Entrar</v-btn>
    </form>
</template>

<style scoped>
    .fluid__login__form {
        width: 100%;
    }
</style>
